import axios, { AxiosInstance } from 'axios';
import { getPakmsKey } from 'utils/Tokenizer';
import { Environment } from 'utils/Environment';

export const getTokenizationBaseUrl = (): string => {
  const { origin } = window.location;
  if (window.location.href.includes('localhost') || origin.includes('localhost')) {
    return 'https://token-dev1.dev.clover.com/';
  }

  if (origin.includes('staging')) {
    return "https://token.staging.clover.com/";
  }

  if (origin.includes('dev') || origin.includes('stg')) {
    const insertIndex = origin.indexOf('//') + 2;

    return `${origin.substring(0, insertIndex)}token-${origin.substring(insertIndex)}/`;
  }

  return 'https://token.clover.com/';
};

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: getTokenizationBaseUrl(),
  headers: {
    'APIKEY': getPakmsKey(process.env.NODE_ENV as Environment),
    'Content-Type': 'application/json',
    'X-Clover-Client-Type': 'HOSTED_CHECKOUT',
  }
});
